import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ValueProposition } from '../components/ValueProposition';
import { MarketOpportunity } from '../components/MarketOpportunity';
import { TargetCustomers } from '../components/TargetCustomers';
import { GoToMarket } from '../components/GoToMarket';
import { BusinessModel } from '../components/BusinessModel';
import { Traction } from '../components/Traction';
import { InvestorAsk } from '../components/InvestorAsk';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-slate-950 text-slate-50 font-sans selection:bg-emerald-500/30" data-id="element-361">
      <Navbar data-id="element-362" />
      <main data-id="element-363">
        <HeroSection data-id="element-364" />
        <ProblemSection data-id="element-365" />
        <SolutionSection data-id="element-366" />
        <ValueProposition data-id="element-367" />
        <MarketOpportunity data-id="element-368" />
        <TargetCustomers data-id="element-369" />
        <GoToMarket data-id="element-370" />
        <BusinessModel data-id="element-371" />
        <Traction data-id="element-372" />
        <InvestorAsk data-id="element-373" />
      </main>
      <Footer data-id="element-374" />
    </div>;
}